import styled from 'styled-components';

import { mediaQuery } from '../../../styles/global';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  max-width: 270px;
  gap: 8px;
  margin-bottom: 16px;
  ${mediaQuery.maxWidth.tablet} {
    max-width: 340px;
  }
`;

export const CaptionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: row;
    justify-content: space-between;
    gap: 32px;
  }
`;

export const Caption = styled.p`
  margin: 10px 0 0;
  font-size: 1.2rem;
`;
export const SubCaption = styled.p`
  font-family: ${({ theme }) => theme.fontFamily.regular};
  letter-spacing: 0.2em;
  margin: 5px 0;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.white75};
`;

export const ImageWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const ImageOverlay = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  aspect-ratio: 1 / 1.15;
  border-radius: 26px;
`;

export const Image = styled.img`
  object-fit: cover;
  aspect-ratio: 1 / 1.15;
  filter: grayscale(1);
  border-radius: 26px;
  width: 100%;
  height: auto;
`;

export const PositionsList = styled.div`
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
`;

export const Link = styled.a`
  margin-top: 24px;
  width: 24px;
  min-width: 48px;
  height: 48px;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  transition: 0.2s ease all;
  &:hover,
  &:active {
    transform: scale(1.05);
  }

  ${mediaQuery.maxWidth.tablet} {
    margin-top: 10px;
  }
`;

export const LinkImage = styled.img``;
